import * as React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import { mediaQueryUp } from 'components/utils/breakpoint'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${rem(322)};
  padding: ${rem(32)} ${rem(20)};

  ${mediaQueryUp.tablet} {
    min-height: ${rem(289)};
    padding: ${rem(40)} ${rem(24)};
  }
`

const ImageWrapper = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;

  > * {
    height: 100%;
    width: 100%;
  }

  picture {
    display: block;
    height: 100%;
    width: 100%;
  }

  img {
    display: block;
  }
`

const BreakpointImage = styled(CSSBreakpoint)`
  height: 100%;
  width: 100%;
`

interface Props extends React.ComponentProps<typeof ResponsiveImage> {
  children?: React.ReactNode
  mobileId?: string
  desktopId?: string
}

function HeroImage(props: Props) {
  const {
    alt,
    children,
    className,
    fit = 'center',
    id,
    mobileId,
    desktopId,
    tabletAspectRatio = '16:9',
    mobileAspectRatio = '4:3',
    ...restOfImageProps
  } = props

  const showBreakpointSpecificImages = !!(mobileId && desktopId)
  const resolvedMobileId = mobileId || id
  const resolvedDesktopId = desktopId || id
  const imageProps = {
    ...restOfImageProps,
    mobileAspectRatio,
    tabletAspectRatio,
    alt,
    fit,
    loading: 'eager' as const,
  }

  return (
    <Root className={className}>
      <ImageWrapper>
        {showBreakpointSpecificImages && (
          <>
            <BreakpointImage max="mobile">
              <ResponsiveImage
                {...imageProps}
                id={resolvedMobileId}
              />
            </BreakpointImage>
            <BreakpointImage min="tablet">
              <ResponsiveImage
                {...imageProps}
                id={resolvedDesktopId}
              />
            </BreakpointImage>
          </>
        )}
        {!showBreakpointSpecificImages && (
          <ResponsiveImage
            {...imageProps}
            id={id}
          />
        )}
      </ImageWrapper>
      {children}
    </Root>
  )
}

export default HeroImage
